import { Table, Button, Pagination } from "flowbite-react";
import { HiPlus, HiPencil } from "react-icons/hi";
import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import { routes } from "../routes";
import { useReducerAsState } from "../hooks/useReducerAsState";
import useHeaders from "../hooks/useHeaders";
import { TableResults } from "../components";

interface State {
    page: number;
    limit: number;
    name: string;
}

const HeadersPage = () => {
    const { headers, loading, error, totalHeaders, fetchHeaders } = useHeaders()

    const [state, setState] = useReducerAsState<State>({
        page: 1,
        limit: 10,
        name: "",
    });

    const navigate = useNavigate();

    const onPageChange = (page: number) => setState({page});

    useEffect(() => {
        (async () => {
            await fetchHeaders({...state})
        })()
        // eslint-disable-next-line
    } ,[state.page])

    return <div className="m-4">
        <div className="flex flex-col mb-4">
            <div className="mb-4">
                <h1>Cabeceras</h1>
            </div>
        </div>
        
        <TableResults
            loading={loading}
            error={error}
            itemsCount={totalHeaders}
        >
            <div className="overflow-x-auto mb-4 w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                <Table>
                    <Table.Head>
                        <Table.HeadCell>Titulo</Table.HeadCell>
                        <Table.HeadCell>
                        </Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                        {headers && headers.map((item) => <Table.Row key={item.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                            <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                {item.name}
                            </Table.Cell>
                            <Table.Cell>
                                <Button onClick={() => navigate(`${routes.DASHBOARD}/${routes.HEADERS}/${item.id}`)} color="gray">
                                    <HiPencil />
                                </Button>
                            </Table.Cell>
                        </Table.Row>)}
                    </Table.Body>
                </Table>
            </div>
        </TableResults>
        {headers && <div className="flex overflow-x-auto sm:justify-center">
            <Pagination currentPage={state.page} totalPages={Math.ceil(totalHeaders / state.limit)} onPageChange={onPageChange} />
        </div>}
    </div>
}

export default HeadersPage